<div class="btn btn__default" (click)="addItem(item)">Agregar al carrito</div>

@if (_isDev) {
  <div class="btn btn__default" (click)="reset()">Reset</div>
}
